<template>
  <router-view />
</template>

<script>
export default {
  name: 'FactoryCapacityIndex'
}
</script>
